import * as React from "react";

import { cn } from "@/lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const inputClass =
  "flex h-14 w-full text-ash-900 rounded-md border border-ash-300 bg-white px-3 py-2 ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-ash-500 focus-visible:outline-hidden focus-visible:ring-[1px] focus-visible:ring-ash-500 disabled:cursor-not-allowed disabled:opacity-50";

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
  return <input type={type} className={cn(inputClass, className)} ref={ref} {...props} />;
});

Input.displayName = "Input";

export { Input, inputClass };
